module.exports = __webpack_public_path__ + "img/plac.a726a62c.jpg";